/**
 * Free-tier product gate (interim, pre-auth). The default role is `free` (see role.ts); this module
 * centralizes WHAT the free tier may touch so the layout, Home, and route guards agree on one contract.
 */
import { getRole, isFreeTier } from './role';

// Top 10 by market cap, EXCLUDING stablecoins (USDT/USDC have no analysable price action). This is the
// only asset universe a free user may analyse; everything else is Pro.
export const FREE_TIER_ASSETS = ['btc', 'eth', 'sol', 'xrp', 'ltc']; // access model 2026-09-24 (server SSOT: /api/tickers/universe)

/** True when the symbol is inside the free-tier top-10 universe. */
export function isFreeAsset(sym: string): boolean {
  return FREE_TIER_ASSETS.includes((sym || '').trim().toLowerCase());
}

/** True when the CURRENT user is on the free tier. */
export function isFreeUser(): boolean {
  return isFreeTier(getRole());
}
